<template>
  <div class="systembody">
    <div style="margin-top: 10px;">
    <div class="sectionLargeIcon largeServerIcon"></div>
    <div class="widget clearfix">
      <span class="title" style="font-size: 22px; margin-right: 15px; font-weight: 600 !important; color: #183677;">
        Upload Files</span>
      <div class="widget_inside" style="margin-top: 15px;">
        <UploadMenu @barUploadItemSelected="openSelected" :routerSelected="routerSelected" />

        <FirstComp v-if="itemSelected === 'page1'" />
        <SecondComp v-if="itemSelected === 'page2'" />
        <ThirdComp v-if="itemSelected === 'page3'" />
        <FourhComp v-if="itemSelected === 'page4'" />
      </div>
    </div>
  </div>
</div>
</template>
<script>
import FirstComp from '@/components/upload/FirstComp'
import SecondComp from '@/components/upload/SecondComp'
import ThirdComp from '@/components/upload/ThirdComp'
import FourhComp from '@/components/upload/FourhComp'
import Auth from '@/services/auth.service.js'
import SideMenu from '@/components/widgets/sideMenu.vue'
import UploadMenu from '@/components/upload/UploadMenu'
import TopBar from '@/components/widgets/TopBar'

export default {
  name: 'upload',
  components: {
    SideMenu,
    TopBar,
    UploadMenu,
    FirstComp,
    SecondComp,
    ThirdComp,
    FourhComp
  },
  data: () => ({
    itemSelected: "page1",
    routerSelected: "",
    isExtended: true,
  }),
  methods: {
    openSelected(itemNum) {
      this.itemSelected = itemNum;
    },
    isExtendedFunc() {
      this.isExtended = !this.isExtended;
    }
  },
  created() {
    document.title = 'Files | clickcall'
    const pageParam = this.$route.params.page;
    if (pageParam) {
      this.routerSelected = pageParam;
      this.openSelected(pageParam)
    } else {
      this.openSelected("page1")
    }

    let auth = Auth.checkAuth();
    if (!auth) {
      this.$router.replace({ name: "login" })
    }
  },
}
</script>
<style scoped>

</style>